import { FC } from 'react';
import { Layout } from '../layout';
import { Navigate, Outlet } from 'react-router-dom';

import type { IUser } from '../../interfaces/user';

interface ProtectedRouteProps {
  user?: IUser | null;
  children: any;
  layout?: string;
  isAllowed: boolean;
  redirectPath?: string;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  user,
  layout,
  children,
  isAllowed,
  redirectPath = '/403'
}) => {
  if (!user) {
    return <Navigate to="/ingresar" replace />;
  }

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? <Layout layout={layout}>{children}</Layout> : <Outlet />;
};
